export default __webpack_public_path__ + "static/media/Novotril-0.5-mg-ban.d63b83a9.jpg";